

import { useEffect, useState } from "react";
import { useNavigate, useLocation,useSearchParams } from "react-router-dom";



const AdminSidebar = ({pageSelected,setPageSelected}) => {    
    const navigate = useNavigate();

    const handleScroll = (id) => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };


    const onClickValueChange = (index) =>{
      var newPageSelection = new Array(4).fill(false);
      newPageSelection[index] = true;
      setPageSelected(newPageSelection);
    }


  const handleLogout = () => {
    navigate("/login?fromSignup=false");
  };

  

  
  
    return (
      <aside className="sidebar">
        <div className="sidebar-content">
            <div className="sidebar-header">
              <div className="sidebar-logo">
                <img src="stockarchiveslogo2.png" alt="stock archive logo" />
              </div>
              <div className="sidebar-title">
                <span>Stock Archives API</span>
                <span className="docs-text">Admin.</span>
              </div>
            </div>
          <div>
          <ul className="sidebar-list">
            <li key={1} className={"sidebar-item"}>
                    <button
                    onClick={() => onClickValueChange(0)}
                    className={pageSelected[0]?"sidebar-button-active":"sidebar-button"}
                    >
                    Automatic Task
                    </button>
             </li>
            
            <li key={2} className={"sidebar-item"}>
                    <button
                    onClick={() => onClickValueChange(1)}
                    className={pageSelected[1]?"sidebar-button-active":"sidebar-button"}
                    >
                    Pending
                    </button>
             </li>
             <li key={3} className="sidebar-item">
                    <button
                    onClick={() => onClickValueChange(2)}
                    className={pageSelected[2]?"sidebar-button-active":"sidebar-button"}
                    >
                    Review
                    </button>
             </li>
             <li key={4} className="sidebar-item">
                    <button
                    onClick={() => onClickValueChange(3)}
                    className={pageSelected[3]?"sidebar-button-active":"sidebar-button"}
                    >
                    Done
                    </button>
             </li>
             <li key={5} className="sidebar-item">
                    <button
                    onClick={() => onClickValueChange(4)}
                    className={pageSelected[4]?"sidebar-button-active":"sidebar-button"}
                    >
                    Redo
                    </button>
             </li>
          </ul>
          </div>
          <button onClick={handleLogout} className="logout-button">
            Logout
          </button>
        </div>
    </aside>
    );
  };
  
  export default AdminSidebar;